import React, { useMemo } from 'react';
import { HelpOutline } from '@mui/icons-material';
import { Grid, Typography, useTheme } from '@mui/material';
import Tippy from '@tippyjs/react';
import { Spacer } from '../../../components';
import { SummedReport } from '../../../models/ReportData';
import { formatNumber } from '../../../helpers/utilityFunctions';
import { getActiveUserCount } from '../../../data/report/helpers/calculationUtils';
import { HelpTitle } from '../../../components/HelpText';

interface ActiveUsersProps {
  summedReport: SummedReport;
}

const ActiveUsers: React.FC<ActiveUsersProps> = ({ summedReport }) => {
  const theme = useTheme();

  const activeUserCount = useMemo(() => getActiveUserCount(summedReport), [summedReport]);

  if (!summedReport) return null;

  return (
    <Grid flexDirection='column' pr={5.5}>
      <Typography variant='p30Bold' color='secondary.main'>
        {formatNumber(activeUserCount)}
      </Typography>
      <Grid container flexDirection='row'>
        <Typography variant='p16' color='secondary.main'>
          Active users
        </Typography>
        <Spacer width='xxxs' />
        <Tippy placement='right' content={<ActiveUsersHelpText />} theme='tippy-rounded'>
          <HelpOutline style={{ color: theme.palette.info.main }} />
        </Tippy>
      </Grid>
    </Grid>
  );
};

export default ActiveUsers;

const ActiveUsersHelpText: React.FC = () => {
  return (
    <Grid>
      <HelpTitle>Active users</HelpTitle>
      <Spacer height='xxs' />
      <Typography color='secondary.dark'>These are accounts with an active license.</Typography>
    </Grid>
  );
};
